// src/components/RequireAuth.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '@/store/useAuthStore';
import { useUserStore } from '@/store';

interface Props {
  children: React.ReactNode;
}

const RequireAuth: React.FC<Props> = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  console.log("RequireAuth Render - isAuthenticated:", isAuthenticated);
  console.log("RequireAuth Render - location.pathname:", location.pathname);

  if (!isAuthenticated && location.pathname !== "/login") {
    console.log("RequireAuth - User not authenticated, logging out and redirecting to /login");
    
    // Clear user store and auth state synchronously
    useAuthStore.getState().logout();
    useUserStore.getState().reset();
    
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
